import type { ReactNode } from 'react'
import {TextH3} from '../../../../ui/Text'
import css from './WorkspaceSettingsTitle.module.css'

interface WorkspaceSettingsTitleProps {
    children: ReactNode
}

const WorkspaceSettingsTitle = ({ children }: WorkspaceSettingsTitleProps) => {
    return <TextH3 className={css.title}>{children}</TextH3>
}

export default WorkspaceSettingsTitle
